import React from 'react';
import { Star, ShieldCheck, Zap, RotateCcw } from 'lucide-react';
export function TrustBar() {
  return <section className="bg-white border-y border-gray-100 py-6 md:py-8" data-id="element-236">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 md:gap-8" data-id="element-238">
          {/* Rating */}
          <div className="flex flex-col items-center md:items-start gap-1" data-id="element-239">
            <div className="flex items-center gap-1" data-id="element-240">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" data-id="element-241" />)}
              <span className="font-bold text-graphite ml-2" data-id="element-242">4.9/5</span>
            </div>
            <p className="text-xs text-gray-500" data-id="element-243">
              [basado en opiniones reales]
            </p>
          </div>

          {/* Features */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-10" data-id="element-244">
            <div className="flex items-center gap-2" data-id="element-245">
              <ShieldCheck className="w-5 h-5 text-primary" data-id="element-246" />
              <span className="text-sm font-medium text-graphite" data-id="element-247">
                Pago seguro
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-248">
              <Zap className="w-5 h-5 text-accent" data-id="element-249" />
              <span className="text-sm font-medium text-graphite" data-id="element-250">
                Entrega inmediata
              </span>
            </div>
            <div className="flex items-center gap-2" data-id="element-251">
              <RotateCcw className="w-5 h-5 text-success" data-id="element-252" />
              <span className="text-sm font-medium text-graphite" data-id="element-253">
                Garantía 7 días
              </span>
            </div>
          </div>

          {/* Social Proof */}
          <div className="text-center md:text-right" data-id="element-254">
            <p className="text-sm font-medium text-graphite bg-gray-50 px-4 py-2 rounded-full border border-gray-100" data-id="element-255">
              Más de <strong className="text-primary" data-id="element-256">250</strong> emprendedoras
              ya dejaron de rogar por ventas
            </p>
          </div>
        </div>
      </div>
    </section>;
}